// ══════════════════════════════════════════════════════════════════════════════════════════════
//  LA NUBE · CÓMO SE ESCRIBEN LOS TAMAÑOS, LAS FECHAS Y LOS TIPOS (fase 2; docs/NUBE-F2-F4-ESPEC.md)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  Puro: ni React ni la API. Los tamaños van en base 1024 con la coma decimal, «como Windows» (Windows llama GB a
//  lo que son GiB, y la clínica compara con lo que ve en su ordenador). Las fechas llegan del servidor como ISO en UTC
//  (TIMESTAMPTZ con «Z»): convertirlas a la hora de quien mira es exacto, no es la trampa de las fechas sin zona.

const K = 1024

// «850 bytes», «12 KB», «3,2 MB», «1,4 GB». Con una decimal por debajo de 100; sin decimales desde 100.
export function tamano(bytes) {
  const b = Number(bytes)
  if (!Number.isFinite(b) || b < 0) return ''
  if (b < K) return b === 1 ? '1 byte' : b + ' bytes'
  const unidades = ['KB', 'MB', 'GB', 'TB']
  let v = b / K
  let i = 0
  while (v >= K && i < unidades.length - 1) { v /= K; i++ }
  const texto = v >= 100 ? String(Math.round(v)) : (Math.round(v * 10) / 10).toFixed(1).replace(/\.0$/, '').replace('.', ',')
  return texto + ' ' + unidades[i]
}

// Solo gigas, con una decimal (la barra de espacio: «3,2 GB de 10 GB»).
export function gigas(bytes) {
  const g = (Number(bytes) || 0) / (K * K * K)
  const t = g >= 100 ? String(Math.round(g)) : (Math.round(g * 10) / 10).toFixed(1).replace(/\.0$/, '').replace('.', ',')
  return t + ' GB'
}

const dosCifras = (n) => String(n).padStart(2, '0')

// «30/09/2026 17:02», en la hora de quien mira.
export function fechaCorta(iso) {
  if (!iso) return ''
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return ''
  return dosCifras(d.getDate()) + '/' + dosCifras(d.getMonth() + 1) + '/' + d.getFullYear() + ' ' + dosCifras(d.getHours()) + ':' + dosCifras(d.getMinutes())
}

// «30/09/2026», sin la hora.
export function dia(iso) {
  if (!iso) return ''
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return ''
  return dosCifras(d.getDate()) + '/' + dosCifras(d.getMonth() + 1) + '/' + d.getFullYear()
}

// El icono de la fila, por el tipo (y la extensión si el tipo no dice nada).
export function iconoDeArchivo(mime, nombre) {
  const m = String(mime || '').toLowerCase()
  const ext = String(nombre || '').toLowerCase().split('.').pop()
  if (m.startsWith('image/') || ['jpg', 'jpeg', 'png', 'webp', 'gif', 'heic', 'tif', 'tiff', 'bmp'].includes(ext)) return 'image'
  if (m.startsWith('video/') || ['mp4', 'mov', 'avi', 'mkv'].includes(ext)) return 'video'
  if (m === 'application/pdf' || ['pdf', 'doc', 'docx', 'odt', 'txt', 'rtf', 'xls', 'xlsx', 'ods', 'csv', 'ppt', 'pptx'].includes(ext)) return 'doc'
  return 'file'
}

// Los archivos que se saltan al subir una carpeta (T10): del sistema o que no sirven fuera de su ordenador. Lo usa la
// cola de subidas (utils/nubeSubidas.js) y se dice cuántos se han saltado.
export function motivoParaSaltar(nombre) {
  const n = String(nombre || '')
  const b = n.toLowerCase()
  if (b === 'thumbs.db' || b === 'desktop.ini' || b === '.ds_store') return 'sistema'
  if (n.startsWith('._')) return 'sistema'
  if (n.startsWith('~$')) return 'bloqueo_office'
  if (b.endsWith('.lnk')) return 'acceso_directo'
  return null
}
export const CARPETAS_DEL_SISTEMA = ['$recycle.bin', 'system volume information']
